import { useEffect } from 'react'

/**
 * Handles person selection from an overlay
 *
 * This hook manages the workflow when a user selects a person from a person overlay
 * and applies that selection to a relationship field.
 *
 * @param {Object} config - Hook configuration
 * @returns {Object} Hook interface
 */
export function usePersonOverlaySelection({
  personIdOverlay,
  setPersonIdOverlay,
  addPersonPanelOverlay,
  relationshipOptions,
  fields,
  methods,
  handleRelationshipChange,
  setChangesMade,
  overlayField,
}) {
  // Get the overlayField from the OverlayContext

  useEffect(() => {
    // Only process when overlay closes and we have all necessary data
    if (addPersonPanelOverlay?.isOpen === false && overlayField.current?.id && personIdOverlay) {
      const selectedPersonOverlay = relationshipOptions.find((rel) => rel.key === personIdOverlay)
      if (selectedPersonOverlay?.key) {
        // Apply the selection to the form and update relationships
        fields.forEach((field, index) => {
          if (field.id === overlayField.current?.id) {
            // Update form values
            const path = `relationships[${index}]`
            if (methods.getValues(path)) {
              methods.setValue(`${path}.value`, {
                key: selectedPersonOverlay.key,
                primaryText: selectedPersonOverlay.primaryText,
              })

              handleRelationshipChange(field)
              methods.trigger()
              setChangesMade(true)
            }
          }
        })
        overlayField.current = null
        setPersonIdOverlay(null)
      }
    }
  }, [
    personIdOverlay,
    addPersonPanelOverlay?.isOpen,
    relationshipOptions,
    fields,
    methods,
    handleRelationshipChange,
    setPersonIdOverlay,
    setChangesMade,
    overlayField,
  ])

  // No need to return anything as overlayField is managed by OverlayContext
  return {}
}

export default usePersonOverlaySelection
